module.exports = __webpack_public_path__ + "img/hero_shelves_summer-sale.8a903068.png";